import Vue from "vue";
import Vuex from "vuex";
import menu from "@/store/menu";
import baseData from "@/store/baseData";
import auth from "@/store/auth";
import postNum from "@/store/postNum"
import { getRegionList } from "@/apis/configure";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // TODO test
    logisticsCompany: [{ label: "OCS", value: "OCS" }],
    pageExclude: "",
  },
  mutations: {
    setKeepAliveLists(state, arrListString) {
      state.pageExclude = arrListString;
      setTimeout(() => {
        state.pageExclude = '';
      }, 500);
    },
  },
  actions: {},
  getters: {
    getLogisticsCompany: (state) => {
      return state.logisticsCompany;
    },
    getUseRole: (state) => {
      let _roles = state.auth.authInfo.roles;
      if (!_roles) {
        const _authInfoJson = window.sessionStorage.getItem("authInfo");
        _roles = !!_authInfoJson ? JSON.parse(_authInfoJson).roles : undefined;
      }
      return _roles;
    },
    getUserName: (state) => {
      let _username = state.auth.authInfo.nick;
      if (!_username) {
        const _authInfoJson = window.sessionStorage.getItem("authInfo");
        _username = !!_authInfoJson
          ? JSON.parse(_authInfoJson).nick
          : undefined;
      }
      return _username;
    },
    getToken: (state) => {
      let _token = state.auth.authInfo.token;
      if (!_token) {
        const _authInfoJson = window.sessionStorage.getItem("authInfo");
        _token = !!_authInfoJson ? JSON.parse(_authInfoJson).token : undefined;
      }
      return _token;
    },
    getWarehouses: (state) => {
      let _warehouses = state.auth.authInfo.warehouses;
      if (!_warehouses) {
        const _authInfoJson = window.sessionStorage.getItem("authInfo");
        _warehouses = !!_authInfoJson
          ? JSON.parse(_authInfoJson).warehouses
          : undefined;
      }
      return _warehouses;
    },
    getWareCode: (state) => {
      let _wareCode = state.auth.wareCode;
      if (!_wareCode || _wareCode === "") {
        _wareCode = window.sessionStorage.getItem("wareCode");
      }
      return _wareCode;
    },
    // getAuthRoutes: (state) =>{
    //   let _routes = state.authRoutes.routes
    //   if (!_routes || !_routes.length) {
    //     _routes = JSON.parse(window.sessionStorage.getItem('authRoutes'))
    //   }
    //   return _routes
    // },
    getMenus: (state) => {
      let _menus = state.menu.menus;
      if (!_menus || !_menus.length) {
        _menus = JSON.parse(window.sessionStorage.getItem("menus"));
      }
      return _menus;
    },
    getRegionList: async (state) => {
      let _regionList = state.baseData.regionList;
      if (!_regionList || !_regionList.length) {
        _regionList = JSON.parse(window.sessionStorage.getItem("regionList"));
      }
      if (!_regionList || !_regionList.length) {
        await getRegionList().then(({ code, data }) => {
          if (code === 0) {
            _regionList = data;
            window.sessionStorage.setItem(
              "regionList",
              JSON.stringify(_regionList)
            );
          }
        });
      }
      return _regionList;
    },
    getPageExclude: (state) => {
      return state.pageExclude;
    },
    getAuthInfo(state) {
      let userId = state.auth.authInfo.userId;
      console.log(state)
      console.log("state")
      let authInfo = state.auth.authInfo
      if (!userId) {
        const _authInfoJson = window.sessionStorage.getItem("authInfo");
        authInfo = !!_authInfoJson
          ? JSON.parse(_authInfoJson)
          : {};
      }
      return authInfo
    },
    getPostNum:(state)=>{
      return state.postNum
    }
  },
  modules: {
    menu,
    baseData,
    auth,
    postNum,
  },
});
